import type { Weapon } from "./Weapon/Weapon.type"

export default function isWeaponUsable(w: Weapon) {
  if ('ammo' in w) {
    return (w.ammo ?? 0) >= (w.ammops ?? 0)
  }
  return true
}
